module.exports = __webpack_public_path__ + "img/4.db57d489.webp";